import { IPages } from '@llws/lift-entity-interfaces';
import { In, IQueryCommandOptions, Not } from '@llws/dynamic-router-utils';
import { INewTranslationSettingsStoreConfig } from '@/shared/interfaces/new-translation-settings';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/website-api/sites/:param/pages';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  where: [
    Not(In('status', ['deleted'])),
  ],
};

const defaultGetSingleFilters: IQueryCommandOptions = {};

const translationSettings: INewTranslationSettingsStoreConfig = {
  model: 'pages',
  keys: ['nav_title'],
};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IPages>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
  translationSettings,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'maintenance/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
